import React, { useState, useEffect } from "react";
import "../css/Login.css";
import api from "../api";
import { useNavigate, Link } from "react-router-dom";
import { showSuccessToast, showErrorToast } from "../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../utils/toastMessages";
import VelaKoda from "../assets/Images/LoginLogo.svg";
import AuthEnterpriseLogo from "../components/AuthEnterpriseLogo";

const images = [
  // "/img/superadminbg1.png",
  "/img/superadminbg2.png",
  "/img/superadminbg5.png",
  "/img/superadminbg3.png",
  "/img/superadminbg4.png",
  "/img/superadminbg5.png",
];

const SendEmail = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const handleSendEmail = async (e) => {
    e.preventDefault();
    if (loading) return;

    // Email validation BEFORE loading starts
    const emailTrimmed = email.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    if (!emailTrimmed) {
      showErrorToast("Please enter your email address.");
      return;
    }

    if (!emailRegex.test(emailTrimmed)) {
      showErrorToast(
        "Please enter a valid email address (e.g., user@example.com)."
      );
      return;
    }

    // ✅ Only set loading to true AFTER validation passes
    setLoading(true);

    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/auth/forgot-password`,
        { email: emailTrimmed }
      );

      const data = response.data;
      showSuccessToast(data.message || TOAST_MESSAGES.AUTH.RESET_CODE_SENT);
      sessionStorage.setItem("resetEmail", emailTrimmed);
      navigate("/verify-email");
    } catch (err) {
      const errorMsg =
        err.response?.data?.message || TOAST_MESSAGES.AUTH.RESET_EMAIL_FAILED;
      showErrorToast(errorMsg);
    } finally {
      // ✅ Always reset loading — no matter what happens
      setLoading(false);
    }
  };

  return (
    <div className="login-container d-flex">
      {/* Left Panel */}
      <div className="login-left">
        {images.map((img, index) => (
          <div
            key={index}
            className={`bg-slide ${index === currentImage ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          >
            {/* Desktop Logo placed on the image */}
            <img src={VelaKoda} alt="logo" className="slide-logo" />
          </div>
        ))}
      </div>
      {/* Right Panel */}
      <div className="login-right d-flex flex-column align-items-start justify-content-center">
        <div className="logo-wrapper">
          <AuthEnterpriseLogo alt="Logo" />
        </div>

        <form
          className="login-form p-4  rounded-3 mt-1 mx-auto"
          onSubmit={handleSendEmail}
          style={{ maxWidth: "420px", width: "100%" }}
        >
          <h3 className="mb-3 text-center refresh-prompts fw-bolder">
            Forgot Password
          </h3>
          <p className="text-center login-p mx-3 refresh-prompts">
            We will send you a code to reset your password.
          </p>

          <div className=" rounded w-100 mb-3">
            <div className="input-group custom-search-group">
              <span className="input-group-text">
                <i className="bi bi-envelope-fill"></i>
              </span>
              <input
                type="email"
                className="form-control"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
            </div>
          </div>

          <button
            type="submit"
            className="btn custom-btn w-100"
            disabled={loading}
          >
            {loading ? "Sending..." : "Continue"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SendEmail;
